import React from "react"
import { EditorState, RichUtils } from "draft-js"
import Editor from "draft-js-plugins-editor"
import createHighlightPlugin from './highlightPlugin'
import { Row, Col, Button, Divider } from "antd";
import styled from '../../../node_modules/styled-components';

const highlightPlugin = createHighlightPlugin();

interface IProp {
    value?: string;
}

class HtmlEditorComponent extends React.Component<IProp, {}> {

    state = {
        editorState: EditorState.createEmpty
    }

    plugins = {

    }

    constructor(props) {
        super(props);
        this.state = {
            editorState: EditorState.createEmpty()
        };
        this.plugins = [
            highlightPlugin,
        ];
    }

    onChange = editorState => {
        this.setState({
            editorState
        });
    };

    handleKeyCommand = command => {
        const newState = RichUtils.handleKeyCommand(
            this.state.editorState,
            command
        );
        if (newState) {
            this.onChange(newState);
            return "handled";
        }
        return "not-handled";
    };

    onUnderlineClick = () => {
        this.onChange(
            RichUtils.toggleInlineStyle(this.state.editorState, "UNDERLINE")
        );
    };

    onBoldClick = () => {
        this.onChange(RichUtils.toggleInlineStyle(this.state.editorState, "BOLD"));
    };

    onItalicClick = () => {
        this.onChange(
            RichUtils.toggleInlineStyle(this.state.editorState, "ITALIC")
        );
    };

    onStrikeThroughClick = () => {
        this.onChange(
            RichUtils.toggleInlineStyle(this.state.editorState, "STRIKETHROUGH")
        );
    };

    onHighlight = () => {
        this.onChange(
            RichUtils.toggleInlineStyle(this.state.editorState, "HIGHLIGHT")
        );
    };

    // Render the editor.
    render(): JSX.Element {
        return (
            <div className="editorContainer">
                <Row>
                    <Col sm={24} md={24} xl={24}>
                        <OptionsButton>
                            <Button className="goepik-html-button" onClick={this.onBoldClick}>B</Button>
                            <Button className="goepik-html-button" onClick={this.onItalicClick}>I</Button>
                            <Button className="goepik-html-button" onClick={this.onUnderlineClick}>U</Button>
                        </OptionsButton>
                    </Col>
                </Row>
                <Row>
                    <Col sm={24} md={24} xl={24}>
                        <GoEpikDividerStyle>
                            <Divider className="goepik-divider" />
                        </GoEpikDividerStyle>
                    </Col>
                </Row>
                <Row>
                    <Col sm={24} md={24} xl={24}>
                        <RickTextStyle>
                            <Editor
                                editorState={this.state.editorState}
                                handleKeyCommand={this.handleKeyCommand}
                                plugins={this.plugins}
                                onChange={this.onChange}

                            />
                        </RickTextStyle>
                    </Col>
                </Row>
            </div>
        );
    }
}

const OptionsButton = styled.div`
    .ant-btn {
        margin-right: 10px;
    }

    .goepik-html-button{
        font-weight: bold;
        color: black;
        border-style: unset;
    }

    .ant-btn, .ant-btn:active, .ant-btn:focus {
        border-style: hidden;
    }
`;

const GoEpikDividerStyle = styled.div`
    .goepik-divider{
        margin-left: 0!important;
        margin-right: 0!important;
        margin-bottom: 0!important;
        margin-top: 0!important;
    }
`;

const RickTextStyle = styled.div`
    padding: 1em;
    min-height: 100px;
`;

export default HtmlEditorComponent;
